var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "advantages-content"
  }, [_c("section", {
    staticClass: "left"
  }, _vm._l(_vm.leftList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "descriptions left_desc"
    }, [_c("div", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c("div", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.desc))]), _c("div", {
      staticClass: "descriptions-bg",
      style: _vm.styleLeft
    })]);
  }), 0), _c("div", {
    staticClass: "middle"
  }, [_c("img", {
    attrs: {
      src: _vm.img,
      alt: ""
    }
  })]), _c("section", {
    staticClass: "right"
  }, _vm._l(_vm.rightList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "descriptions"
    }, [_c("div", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c("div", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.desc))]), _c("div", {
      staticClass: "descriptions-bg"
    })]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };